import * as React from 'react';
const SvgConnectionError = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={240}
    fill="none"
    viewBox="0 0 241 240"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M.5 0h240v240H.5z" />
    <path
      fill="#E9F2FF"
      d="M120.5 204c46.392 0 84-37.608 84-84s-37.608-84-84-84-84 37.608-84 84 37.608 84 84 84"
    />
    <path
      fill="#05C"
      fillRule="evenodd"
      d="M232.401 151.48a4.196 4.196 0 0 1-1.436 5.756c-14.931 8.972-31.856 10.681-48.052 10.144a4.193 4.193 0 0 1-4.051-4.332 4.194 4.194 0 0 1 4.329-4.054c15.544.515 30.553-1.198 43.457-8.951a4.19 4.19 0 0 1 5.753 1.437"
      clipRule="evenodd"
    />
    <path
      fill="#16E"
      d="M136.936 130.481c4.409 2.925 8.179 7.314 10.952 12.694l.03.012a49.63 49.63 0 0 1 0 43.752c-2.764 5.38-6.528 9.765-10.932 12.688h22.869c14.279 0 25.857-15.475 25.857-34.57s-11.578-34.576-25.857-34.576z"
    />
    <path
      fill="#16E"
      d="M147.888 143.175c-5.199-10.087-13.902-16.692-23.755-16.692h-9.517c-15.933 0-28.852 17.273-28.852 38.574s12.92 38.568 28.852 38.574h9.547c9.853 0 18.568-6.593 23.755-16.692a49.63 49.63 0 0 0 0-43.752z"
    />
    <path
      fill="#59F"
      d="M138.263 143.175c-5.187-10.069-13.872-16.668-23.707-16.692-15.92 0-28.822 17.285-28.822 38.574s12.901 38.55 28.822 38.574c9.835 0 18.52-6.593 23.707-16.692a49.57 49.57 0 0 0 0-43.752z"
    />
    <path
      fill="#05C"
      d="M118.418 157.945c-1.405 2.523-3.756 4.176-6.419 4.182-4.311 0-7.804-4.331-7.804-9.664s3.493-9.657 7.804-9.663c2.663 0 5.014 1.651 6.419 4.181a11.67 11.67 0 0 1 1.377 5.481c0 1.9-.471 3.775-1.377 5.48zM118.418 183.962c-1.405 2.523-3.756 4.176-6.419 4.182-4.311 0-7.804-4.33-7.804-9.664s3.493-9.657 7.804-9.663c2.663 0 5.014 1.652 6.419 4.182a11.66 11.66 0 0 1 1.377 5.48c0 1.9-.471 3.775-1.377 5.48z"
    />
    <path
      fill="#16E"
      d="M80.423 152.463a6.69 6.69 0 0 1 6.69-6.69h23.764a6.69 6.69 0 1 1 0 13.38H87.114a6.69 6.69 0 0 1-6.69-6.69M80.423 178.48a6.69 6.69 0 0 1 6.69-6.69h23.764a6.69 6.69 0 0 1 0 13.381H87.114a6.69 6.69 0 0 1-6.69-6.691"
    />
    <path
      fill="#05C"
      fillRule="evenodd"
      d="M10.035 83.31c14.933-8.974 31.85-10.682 48.046-10.145a4.194 4.194 0 0 1 4.051 4.332 4.194 4.194 0 0 1-4.329 4.054c-15.544-.515-30.546 1.197-43.451 8.952a4.19 4.19 0 0 1-5.753-1.437 4.197 4.197 0 0 1 1.436-5.757"
      clipRule="evenodd"
    />
    <path
      fill="#16E"
      d="M104.1 45.677c-4.425 2.925-8.21 7.324-10.993 12.718a48 48 0 0 0-5.085 21.882 48 48 0 0 0 5.085 21.882c2.76 5.365 6.512 9.741 10.902 12.664H81.145c-14.279 0-25.863-15.475-25.863-34.57s11.584-34.576 25.863-34.576z"
    />
    <path
      fill="#16E"
      d="M93.107 58.395c5.205-10.087 13.908-16.692 23.761-16.692h9.547c15.933 0 28.852 17.273 28.852 38.574s-12.919 38.568-28.852 38.574h-9.547c-9.853 0-18.568-6.593-23.76-16.692a48 48 0 0 1-5.086-21.882 48 48 0 0 1 5.085-21.882"
    />
    <path
      fill="#59F"
      d="M102.731 58.395c5.193-10.069 13.872-16.668 23.713-16.692 15.92 0 28.822 17.285 28.822 38.574s-12.902 38.55-28.822 38.568c-9.841 0-18.52-6.593-23.713-16.686a48 48 0 0 1-5.085-21.882 48 48 0 0 1 5.085-21.882"
    />
    <path
      fill="#05C"
      d="M128.924 73.672c3.113 0 5.636-3.504 5.636-7.827s-2.523-7.827-5.636-7.827-5.636 3.504-5.636 7.827 2.523 7.827 5.636 7.827M128.924 103.407c3.113 0 5.636-3.505 5.636-7.828s-2.523-7.827-5.636-7.827-5.636 3.504-5.636 7.827 2.523 7.828 5.636 7.828"
    />
    <path
      fill="#F77167"
      d="M212.228 91.677a28.16 28.16 0 0 1-5.193 12.963 27.8 27.8 0 0 1-10.756 8.813 27.53 27.53 0 0 1-26.759-2.023l-10.676 3.669a1.77 1.77 0 0 1-1.868-.48 1.81 1.81 0 0 1-.339-1.914l4.295-10.343a28.2 28.2 0 0 1-3.874-12.627 28.2 28.2 0 0 1 2.297-13.013 28 28 0 0 1 7.957-10.5 27.64 27.64 0 0 1 11.843-5.646 27.5 27.5 0 0 1 13.091.464 27.7 27.7 0 0 1 11.42 6.473 28 28 0 0 1 7.206 11.038 28.2 28.2 0 0 1 1.385 13.144z"
    />
    <path
      fill="#fff"
      d="M188.5 102.222c0 .996-.88 1.778-2 1.778h-4c-1.12 0-2-.782-2-1.778v-3.555c0-.996.88-1.778 2-1.778h4c1.12 0 2 .782 2 1.778zm0-10.666c0 .995-.88 1.777-2 1.777h-4c-1.12 0-2-.782-2-1.777V73.778c0-.996.88-1.778 2-1.778h4c1.12 0 2 .782 2 1.778z"
    />
    <path
      fill="#59F"
      fillRule="evenodd"
      d="M45 106.398a1.9 1.9 0 0 0 1.904-1.898A1.9 1.9 0 0 0 45 102.602a1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898M45 109a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M195 188.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M77 30.398a1.9 1.9 0 0 0 1.904-1.898A1.9 1.9 0 0 0 77 26.602a1.9 1.9 0 0 0-1.904 1.898A1.9 1.9 0 0 0 77 30.398M77 33a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M175.508 37.568c.505-2.09 3.478-2.09 3.983 0l.764 3.166c.18.747.764 1.33 1.511 1.51l3.166.765c2.09.504 2.09 3.478 0 3.982l-3.166.765a2.05 2.05 0 0 0-1.511 1.51l-.764 3.166c-.505 2.09-3.478 2.09-3.983 0l-.764-3.166a2.05 2.05 0 0 0-1.511-1.51l-3.166-.765c-2.09-.504-2.09-3.478 0-3.982l3.166-.765a2.05 2.05 0 0 0 1.511-1.51zM43.396 133.655c.534-2.207 3.674-2.207 4.208 0l.712 2.941a2.17 2.17 0 0 0 1.597 1.595l2.929.705c2.21.532 2.21 3.676 0 4.208l-2.928.705c-.79.19-1.407.806-1.598 1.595l-.712 2.941c-.534 2.207-3.674 2.207-4.208 0l-.712-2.941a2.17 2.17 0 0 0-1.597-1.595l-2.929-.705c-2.21-.532-2.21-3.676 0-4.208l2.928-.705a2.17 2.17 0 0 0 1.598-1.595zM74.568 190.665c1.366-.239 2.48 1.088 2.004 2.388l-2.616 7.15c-.476 1.3-2.184 1.598-3.075.537l-4.898-5.838c-.89-1.062-.296-2.687 1.07-2.925zM191.014 129.463c-.337-1.342.909-2.545 2.243-2.165l7.336 2.09c1.334.38 1.756 2.058.759 3.02l-5.482 5.294c-.997.963-2.664.488-3.001-.855z"
    />
  </svg>
);
export default SvgConnectionError;
